<loader-detail *ngIf="busy"></loader-detail>
<best-room-pricebox-mobile
  *ngIf="!busy"
  [hotelId]="hotelStatic.id"
  [bestAvailable]="bestAvailable"
  [isLanding]="isLanding"
  [showAmountTotal]="showAmountTotal"
  [city]="hotelStatic.city"
  [country]="hotelStatic.country"
  [hotelName]="hotelStatic.name"
  [hotelStars]="hotelStatic.stars"
  [isDisney]="isDisney"
  (selectTab)="goToRoomsTab()"
></best-room-pricebox-mobile>
